import { WebglObject } from "../../../../web-graphics";

export class Grid extends WebglObject {
  constructor(settings) {
    super(settings);

    this.buffers = Grid.createGridBuffer(this.settings);

    this.uniforms = {
      u_color: new Float32Array(this.settings.color),
      u_shift: new Float32Array([0.0, 0.0]),
      u_rollIndex: 0,
      u_scale: new Float32Array([1, 1]),
      u_windowSize: new Float32Array([this.settings.canvas.settings.sizeInPixels.width, this.settings.canvas.settings.sizeInPixels.height])
    };
  }

  static createGridBuffer(settings) {
    const buffer = {
      posAttribLoc: settings.program.attribs.a_position
    };

    const x = settings.absoluteLocation.x;
    const y = settings.absoluteLocation.y;
    const bufferX = [];
    const bufferY = [];
    let beginX = x;
    let beginY = y;

    let cellCountByX = Math.ceil(settings.sizeInPixels.width / settings.cellSize[0]);

    buffer.width = cellCountByX * settings.cellSize[0];
    let endX = x + settings.sizeInPixels.width;
    let endY = y + settings.sizeInPixels.height;

    while (beginX < endX) {
      if (beginX + settings.cellSize[0] > endX) {
        beginX = endX;
      } else {
        beginX += settings.cellSize[0];
      }
      bufferX.push(beginX);
      bufferX.push(y);
      bufferX.push(beginX);
      bufferX.push(y + settings.sizeInPixels.height);
    }

    while (beginY < endY) {
      if (beginY + settings.cellSize[1] > endY) {
        beginY = endY;
      } else {
        beginY += settings.cellSize[1];
      }

      bufferY.push(x);
      bufferY.push(beginY);
      bufferY.push(x + settings.sizeInPixels.width);
      bufferY.push(beginY);
    }

    buffer.dataBufferX = new Float32Array(bufferX);
    buffer.glBufferX = settings.gl.createBuffer();
    settings.gl.bindBuffer(settings.gl.ARRAY_BUFFER, buffer.glBufferX);
    settings.gl.bufferData(settings.gl.ARRAY_BUFFER, buffer.dataBufferX, settings.gl.STATIC_DRAW);

    buffer.dataBufferY = new Float32Array(bufferY);
    buffer.glBufferY = settings.gl.createBuffer();
    settings.gl.bindBuffer(settings.gl.ARRAY_BUFFER, buffer.glBufferY);
    settings.gl.bufferData(settings.gl.ARRAY_BUFFER, buffer.dataBufferY, settings.gl.STATIC_DRAW);

    return buffer;
  }

  createBorders() {
    super.createBorders();
    this.updateDataBuffer();
  }

  // plotSize: [width, height], windowSize: [width, height]
  updateDataBuffer() {
    this.uniforms.u_windowSize = new Float32Array([this.settings.canvas.settings.sizeInPixels.width, this.settings.canvas.settings.sizeInPixels.height]);
    this.buffers = Grid.createGridBuffer(this.settings);
  }

  draw(gl, program) {
    gl.viewport(0, 0, this.uniforms.u_windowSize[0], this.uniforms.u_windowSize[1]);

    program.setUnforms(this.uniforms);
    gl.enableVertexAttribArray(program.attribs.a_position);
    gl.bindBuffer(gl.ARRAY_BUFFER, this.buffers.glBufferX);
    gl.vertexAttribPointer(program.attribs.a_position, 2, gl.FLOAT, false, 0, 0);
    gl.drawArrays(gl.LINES, 0, this.buffers.dataBufferX.length / 2);

    gl.bindBuffer(gl.ARRAY_BUFFER, this.buffers.glBufferY);
    gl.vertexAttribPointer(program.attribs.a_position, 2, gl.FLOAT, false, 0, 0);
    gl.drawArrays(gl.LINES, 0, this.buffers.dataBufferY.length / 2);
    /*
    program.setUnforms(this.uniforms);
    gl.bindBuffer(gl.ARRAY_BUFFER, this.buffers.glBufferY);
    //gl.bufferData(gl.ARRAY_BUFFER, this.dataBuffer.bufferY, gl.STATIC_DRAW);
    gl.drawArrays(gl.LINES, 0, this.buffers.dataBufferY.length / 2);
    */
  }
}
